/* eslint-disable */
import { initializeApp } from "firebase/app";
// 1. 사용할 서비스(Firestore)를 불러옵니다.
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBrxElmlvgb0u8qbw_Up_SeAS_PuXFHW78",
  authDomain: "datacollection-4cf40.firebaseapp.com",
  projectId: "datacollection-4cf40",
  storageBucket: "datacollection-4cf40.firebasestorage.app",
  messagingSenderId: "480099897277",
  appId: "1:480099897277:web:2f474736bd7b7de1ca4cd4"
};

// 2. Firebase 초기화
const app = initializeApp(firebaseConfig);

// 3. 초기화된 app을 바탕으로 Firestore(DB)를 가져와서 export 합니다.
// 'app'을 인자로 넣음으로써 no-unused-vars 에러도 자연스럽게 해결됩니다.
export const db = getFirestore(app);
export const auth = getAuth(app);
